import React, { useEffect, useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import SideNavBar from './SideNavBar';

const AddFinancialTransaction = () => {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved === 'true'; // Convert string to boolean
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef();

  // Close sidebar when clicking outside (mobile)
  useEffect(() => {
    if (!sidebarOpen) return;
    function handleClick(e) {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setSidebarOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [sidebarOpen]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);
  return (
    <div className={darkMode ? 'dark:bg-gray-900 min-h-screen' : 'bg-white min-h-screen'}>
      <button
        className={`fixed top-4 right-4 z-50 border-2 border-green-700 rounded-full p-2 shadow-lg transition hover:bg-green-700 hover:text-white
          ${darkMode ? 'bg-gray-800 text-yellow-400' : 'bg-white text-green-800'}`}
        onClick={() => setDarkMode(prev => !prev)}
        aria-label="Toggle dark mode"
      >
        {darkMode ? (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 3v1m0 16v1m8.66-13.66l-.71.71M4.05 19.95l-.71.71M21 12h-1M4 12H3m16.66 4.95l-.71-.71M4.05 4.05l-.71-.71M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        ) : (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z"
            />
          </svg>
        )}
      </button>
      {/* Hamburger for mobile */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-white text-black shadow-lg transition-colors duration-300 hover:bg-green-700 hover:text-white"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open sidebar"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>{' '}
      <div className="flex">
        <div
          className={`w-52 h-screen overflow-y-auto bg-gradient-to-r ${
            darkMode ? 'from-gray-900 to-gray-800' : 'from-green-800 to-yellow-200'
          } p-3 font-bold custom-scrollbar hidden md:block`}
        >
          <SideNavBar darkMode={darkMode} />
        </div>
        {/* Mobile sidebar overlay */}
        {sidebarOpen && <div className="fixed inset-0 z-40  bg-black bg-opacity-40 md:hidden" />}
        <div
          ref={sidebarRef}
          className={`fixed top-0 left-0 z-50 w-64 h-full bg-gradient-to-r ${
            darkMode ? 'from-gray-900 to-gray-800' : 'from-green-800 to-yellow-200'
          } p-3 font-bold custom-scrollbar transform transition-transform duration-300 md:hidden
            ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
          style={{ maxWidth: '16rem', overflowY: 'auto' }} // <-- Make mobile sidebar scrollable
        >
          <div className="flex justify-between items-center mb-4">
            <span className="font-bold text-lg text-white">Menu</span>
            <button
              className="p-2 rounded-md bg-gray-200 dark:bg-gray-100"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close sidebar"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <SideNavBar darkMode={darkMode} />
        </div>
        {/* Main Content */}
        <div className="flex-1 md:ml-10  h-screen w-full overflow-y-scroll">
          <div
            className={`font-bold  text-2xl ${
              darkMode
                ? ' bg-gray-800 w-96 mx-auto md:w-11/12 md:mx-0 text-center md:text-left p-4 rounded-md'
                : ' bg-green-900 w-96 mx-auto md:mx-0 md:w-11/12 text-center md:text-left p-4 rounded-md'
            }`}
          >
            <h2 className={`font-bold text-2xl ${darkMode ? 'text-green-200' : 'text-white'}`}>
              Add Financial Transaction
            </h2>
            <p
              className={`font-semibold mt-3 text-sm ${darkMode ? 'text-green-200' : 'text-white'}`}
            >
              Record a new financial transaction for L.F.C Amoyo
            </p>
            <p
              className={`font-semibold mt-3 text-sm ${
                darkMode
                  ? 'text-green-200 md:w-96 text-center bg-gray-600 p-2 rounded-md'
                  : 'text-green-900 md:w-96 text-center bg-gray-200 p-2 rounded-md '
              }`}
            >
              Note: Fill in the form below to record a new transaction
            </p>
            <NavLink to="/finance">
              <h1
                className={`font-semibold mt-3 text-sm ${
                  darkMode
                    ? 'text-green-200 w-40 md:w-40 text-center bg-gray-600 p-2 rounded-md'
                    : 'text-green-900 w-40 md:ml-auto md:w-40  text-center bg-gray-200 p-2 rounded-md '
                }`}
              >
                &gt; Back to Finance
              </h1>
            </NavLink>
          </div>
          <div
            className={`shadow-2xl p-3 mt-6 font-bold md:gap-4  rounded-md ${
              darkMode ? 'bg-gray-800 w-96 md:w-11/12' : 'bg-white w-96 md:w-11/12'
            }  text-gray-700 text-xl`}
          >
            <div className="md:flex">
              <div>
                <label
                  htmlFor="incomecategory"
                  className={`block mt-3  ${
                    darkMode
                      ? 'text-green-200 w-96 mx-auto md:mx-0 md:w-11/12 text-left md:text-left p-4  rounded-md '
                      : ' w-96  mx-auto md:mx-0 md:w-11/12 text-left md:text-left p-4 md:rounded-md text-gray-700'
                  }`}
                >
                  Income Category
                </label>
                <select
                  className={`font-semibold text-sm  ${
                    darkMode
                      ? 'bg-gray-600 border-2 text-green-200 md:w-96 mx-auto border-dotted w-11/12 ml-4 rounded-md border-gray-400 p-3'
                      : 'bg-white border-2 p-3 text-gray-700 md:w-96 border-dotted mx-auto w-11/12 ml-4 rounded-md border-gray-500'
                  }`}
                  name="incomecategory"
                  id="incomecategory"
                >
                  <option value="0">Select Income Category</option>
                  <option value="1">Tithe</option>
                  <option value="2">Offering</option>
                  <option value="3">Project Offering</option>
                  <option value="4">Seed</option>
                  <option value="5">Shiloh Sacrifice</option>
                  <option value="6">Welfare</option>
                  <option value="7">Others</option>
                </select>
              </div>
              <div>
                <label
                  htmlFor="amount"
                  className={`block mt-3  ${
                    darkMode
                      ? 'text-green-200 w-96 mx-auto md:mx-0 md:w-11/12 text-left md:text-left p-4  rounded-md '
                      : ' w-96  mx-auto md:mx-0 md:w-11/12 text-left md:text-left p-4 md:rounded-md text-gray-700'
                  }`}
                >
                  Amount
                </label>
                <input
                  type="number"
                  name="amount"
                  id="amount"
                  placeholder="Amount here"
                  className={`font-semibold text-sm  ${
                    darkMode
                      ? 'bg-gray-600 border-2 text-green-200 md:w-96 mx-auto border-dotted w-11/12 ml-4 rounded-md border-gray-400 p-3'
                      : 'bg-white border-2 p-3 text-gray-700 md:w-96 border-dotted mx-auto w-11/12 ml-4 rounded-md border-gray-500'
                  }`}
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="transactiondate"
                className={`block mt-3  ${
                  darkMode
                    ? 'text-green-200 w-96 mx-auto md:mx-0 md:w-11/12 text-left md:text-left p-4  rounded-md '
                    : ' w-96  mx-auto md:mx-0 md:w-11/12 text-left md:text-left p-4 md:rounded-md text-gray-700'
                }`}
              >
                Transaction Date
              </label>
              <input
                type="date"
                name="transactiondate"
                id="transactiondate"
                className={`font-semibold text-sm  ${
                  darkMode
                    ? 'bg-gray-600 border-2 text-green-200 md:w-96 mx-auto border-dotted w-11/12 ml-4 rounded-md border-gray-400 p-3'
                    : 'bg-white border-2 p-3 text-gray-700 md:w-96 border-dotted mx-auto w-11/12 ml-4 rounded-md border-gray-500'
                }`}
              />
            </div>
            <div>
              <label
                htmlFor="description"
                className={`block mt-3  ${
                  darkMode
                    ? 'text-green-200 w-96 mx-auto md:mx-0 md:w-11/12 text-left md:text-left p-4  rounded-md '
                    : ' w-96  mx-auto md:mx-0 md:w-11/12 text-left md:text-left p-4 md:rounded-md text-gray-700'
                }`}
              >
                Description (optional)
              </label>
              <textarea
                name="description"
                id="description"
                className={`font-semibold  text-sm  ${
                  darkMode
                    ? 'bg-gray-600 border-2 text-green-200 md:w-11/12 mx-auto border-dotted w-11/12 ml-4 rounded-md border-gray-400 p-3'
                    : 'bg-white border-2 p-3 text-gray-700 md:w-11/12 border-dotted mx-auto w-11/12 ml-4 rounded-md border-gray-500'
                }`}
              ></textarea>
            </div>
            <div className="md:flex flex  md:flex-row md:gap-3  ">
              <div className="mt-10 text-end">
                <NavLink>
                  <h1
                    className={`font-semibold  text-sm  ${
                      darkMode
                        ? 'bg-red-500 text-center   text-green-200 md:w-40 mx-auto border-dotted text-xl w-40 ml-4 rounded-md border-gray-400 p-3'
                        : 'bg-red-500 text-center   p-3 text-white md:w-40 border-dotted mx-auto w-40 text-xl ml-4 rounded-md border-gray-500'
                    }`}
                  >
                    Reset Form
                  </h1>
                </NavLink>
              </div>
              <div className="mt-10 text-end">
                <NavLink>
                  <h1
                    className={`font-semibold  text-sm  ${
                      darkMode
                        ? 'bg-gradient-to-r from-green-600 to-yellow-600 text-center   text-green-200 md:w-52 mx-auto border-dotted text-xl w-44 ml-4 rounded-md border-gray-400 p-3'
                        : 'bg-gradient-to-r from-green-600 to-yellow-600 text-center   p-3 text-white md:w-52 border-dotted mx-auto w-44 text-xl ml-4 rounded-md border-gray-500'
                    }`}
                  >
                    Save Transaction
                  </h1>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
    </div>
  );
};

export default AddFinancialTransaction;
